module.exports = __webpack_public_path__ + "img/home-2.4330f921.webp";